// import CryptoJS from "crypto-js";
// import { showError } from "./toast";
// import { notifyTokenChange } from "./tokenEvents";

// const SECRET_KEY = import.meta.env.REACT_APP_SECRET_KEY || "default_secret_key"; // Use environment variable for better security

// // Encrypt data
// export const encryptData = (data) => {
//   return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
// };

// // Decrypt data
// export const decryptData = (cipherText) => {
//   try {
//     const bytes = CryptoJS.AES.decrypt(cipherText, SECRET_KEY);
//     return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
//   } catch (error) {
//     // showError(error["detail"] && typeof error["detail"] !== "object" ? error["detail"] : error["detail"]?.[0]?.msg || "An unknown error occurred.");
//     return null;
//   }
// };

// // Store encrypted data in sessionStorage
// export const setSecureItem = (key, value) => {
//   const encryptedData = encryptData(value);
//   localStorage.setItem(key, encryptedData);

//   if (key === "authToken") {
//     notifyTokenChange();
//   }
// };

// // Retrieve and decrypt data from sessionStorage
// export const getSecureItem = (key) => {
//   const encryptedData = localStorage.getItem(key);
//   if (encryptedData) {
//     return decryptData(encryptedData);
//   }
//   return null;
// };

// // Remove data from sessionStorage
// export const removeSecureItem = (key) => {
//   localStorage.removeItem(key);
// };

import CryptoJS from "crypto-js";
import { notifyTokenChange } from "./tokenEvents";

// const SECRET_KEY = import.meta.env.REACT_APP_SECRET_KEY || "g;zGE.(bdH*R5qK`}V?/2g0W4S@!$6vCGEwkp;^Q*D5T036?Qj'mHfJ--;d2[m9";
const SECRET_KEY = process.env.REACT_APP_SECRET_KEY || "g;zGE.(bdH*R5qK`}V?/2g0W4S@!$6vCGEwkp;^Q*D5T036?Qj'mHfJ--;d2[m9";

// Encrypt data
export const encryptData = (data) =>
  CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();

// Decrypt data
export const decryptData = (cipherText) => {
  try {
    const bytes = CryptoJS.AES.decrypt(cipherText, SECRET_KEY);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  } catch (error) {
    return null;
  }
};

// Set encrypted data in localStorage
export const setSecureItem = (key, value) => {
  const encrypted = encryptData(value);
  localStorage.setItem(key, encrypted);

  // Notify other tabs of token changes
  if (key === "authToken") {
    notifyTokenChange();
  }
};

// Get decrypted data from localStorage
export const getSecureItem = (key) => {
  const encrypted = localStorage.getItem(key);
  return encrypted ? decryptData(encrypted) : null;
};

// Remove data from localStorage
export const removeSecureItem = (key) => {
  localStorage.removeItem(key);
};
